module.exports = __webpack_public_path__ + "img/Gambia.7d8d6e69.svg";